<template>
  <v-container fluid>
    <v-data-table :headers="headers" :items="projects" :search="search" class="elevation-1">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Proyectos</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field
            class="mt-4"
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            dense
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined class="mb-2" @click="openCreate">
            <v-icon left>add</v-icon>
            Nuevo proyecto
          </v-btn>

          <!-- ==================== FORM DIALOG ==================== -->
          <v-dialog
            v-model="dialog"
            max-width="1080"
            persistent
            scrollable
            transition="dialog-bottom-transition"
          >
            <v-card>
              <v-toolbar flat dense color="primary" dark>
                <v-icon left>mdi-home-city-outline</v-icon>
                <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="close">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>

              <v-card-text class="pa-6">
                <v-row>
                  <!-- ---------- Datos del proyecto ---------- -->
                  <v-col cols="12" md="7">
                    <div class="text-overline grey--text text--darken-1 mb-2">
                      Datos del proyecto
                    </div>

                    <v-row dense>
                      <v-col cols="12" sm="4">
                        <v-autocomplete
                          dense
                          outlined
                          v-model="editedItem.business_unit_id"
                          :items="itemsBussines"
                          label="Unidad de negocio"
                          prepend-inner-icon="corporate_fare"
                          @change="
                            itemsLocations2 = updateCombo(
                              itemsLocations,
                              itemsLocations2,
                              editedItem.business_unit_id,
                              'location'
                            )
                          "
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="4">
                        <v-autocomplete
                          dense
                          outlined
                          v-model="editedItem.location_id"
                          :items="itemsLocations2"
                          label="Location"
                          prepend-inner-icon="my_location"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="4">
                        <v-autocomplete
                          dense
                          outlined
                          v-model="editedItem.department_id"
                          :items="itemsDepartment"
                          label="Departamento"
                          prepend-inner-icon="mdi-office-building-outline"
                        ></v-autocomplete>
                      </v-col>
                    </v-row>

                    <v-row dense>
                      <v-col cols="12" sm="8">
                        <v-text-field
                          dense
                          outlined
                          v-model="editedItem.name"
                          label="Nombre del proyecto"
                          prepend-inner-icon="mdi-format-title"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="4">
                        <v-text-field
                          dense
                          outlined
                          v-model="editedItem.code"
                          label="Código"
                          prepend-inner-icon="mdi-pound"
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row dense>
                      <v-col cols="12" sm="6">
                        <v-menu
                          v-model="menu"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              dense
                              outlined
                              v-model="dateFormatDMY"
                              label="Desde"
                              prepend-inner-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="date" @input="menu = false"></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-menu
                          v-model="menu2"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              dense
                              outlined
                              v-model="date2FormatDMY"
                              label="Hasta"
                              prepend-inner-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="date2" @input="menu2 = false"></v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>

                    <v-row dense>
                      <v-col cols="12" sm="8">
                        <v-text-field
                          dense
                          outlined
                          v-model="editedItem.contract_code"
                          label="Código de contrato"
                          prepend-inner-icon="mdi-file-document-outline"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>

                  <!-- ---------- Contrato (archivo) ---------- -->
                  <v-col cols="12" md="5">
                    <div class="text-overline grey--text text--darken-1 mb-2">
                      Contrato
                    </div>

                    <v-file-input
                      v-show="false"
                      id="fileInput"
                      v-model="url_image"
                      accept="application/pdf,image/*"
                      @change="onFileChange"
                    ></v-file-input>

                    <v-card outlined>
                      <!-- Preview seguro: solo se muestra si la URL es un archivo válido -->
                      <div v-if="contractPreviewSrc" style="position: relative">
                        <iframe
                          :src="contractPreviewSrc"
                          style="width: 100%; height: 420px; border: 0; display: block"
                        ></iframe>
                        <v-btn
                          small
                          color="primary"
                          class="ma-2"
                          style="position: absolute; top: 0; right: 0"
                          @click="takeImage()"
                        >
                          <v-icon left small>mdi-swap-horizontal</v-icon>
                          Cambiar
                        </v-btn>
                      </div>

                      <!-- Zona para subir cuando no hay archivo -->
                      <v-hover v-else v-slot="{ hover }">
                        <div
                          @click="takeImage()"
                          :class="hover ? 'grey lighten-3' : 'grey lighten-4'"
                          style="
                            height: 420px;
                            cursor: pointer;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                          "
                        >
                          <v-icon color="grey" size="56">mdi-cloud-upload-outline</v-icon>
                          <div class="grey--text text--darken-1 mt-2">
                            Haz clic para adjuntar el contrato
                          </div>
                          <div class="grey--text text-caption">PDF o imagen</div>
                        </div>
                      </v-hover>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-divider></v-divider>
              <v-card-actions class="pa-4">
                <v-spacer></v-spacer>
                <v-btn text @click="close">Cancelar</v-btn>
                <v-btn color="primary" :loading="saving" @click="save">
                  <v-icon left>mdi-content-save</v-icon>
                  Guardar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- ==================== /FORM DIALOG ==================== -->

          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5">¿Seguro que deseas eliminar este proyecto?</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete">Cancelar</v-btn>
                <v-btn color="blue darken-1" text @click="deleteItemConfirm">Aceptar</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import moment from "moment";
export default {
  name: "projects-view",
  data() {
    return {
      dialog: false,
      dialogDelete: false,
      saving: false,
      search: "",
      headers: [
        { text: "Código", align: "start", sortable: false, value: "code" },
        { text: "Nombre", value: "name" },
        { text: "Unidad negocio", value: "business_description_long" },
        { text: "Location", value: "location_description_long" },
        { text: "Fecha inicio", value: "start_date" },
        { text: "Fecha final", value: "end_date" },
        { text: "Acciones", value: "actions", sortable: false },
      ],
      projects: [],
      editedIndex: -1,
      editedItem: {},
      defaultItem: {},
      image_storage: null,
      date: moment().startOf("month").format("YYYY-MM-DD"),
      date2: moment().endOf("month").format("YYYY-MM-DD"),
      menu: false,
      menu2: false,
      url_image: "",
      itemsDepartment: [],
      filters: {
        business: null,
        location: null,
        department_id: null,
        warehouse_id: null,
      },
      itemsBussines: [],
      itemsLocations: [],
      itemsLocations2: [],
    };
  },
  created() {
    this.init();
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Proyecto" : "Editar Proyecto";
    },
    dateFormatDMY() {
      return moment(this.date).format("DD/MM/YYYY");
    },
    date2FormatDMY() {
      return moment(this.date2).format("DD/MM/YYYY");
    },
    // Guard: nunca embeber la propia app en el iframe.
    // Solo se permite un archivo local recién elegido (blob:/data:)
    // o una URL de un origen externo (storage/pocketbase).
    contractPreviewSrc() {
      const src = this.image_storage;
      if (!src || typeof src !== "string") return null;
      if (src.startsWith("blob:") || src.startsWith("data:")) return src;
      try {
        const u = new URL(src, window.location.origin);
        if (!/^https?:$/.test(u.protocol)) return null;
        if (u.origin === window.location.origin) return null;
        return src;
      } catch (e) {
        return null;
      }
    },
  },

  methods: {
    async init() {
      const response = await this.api_Get("project/projects");
      this.projects = await response.json();

      this.itemsBussines = Object.assign([], this.$store.state.auth.bussines_units);
      this.filters.business = this.itemsBussines[0].value;
      this.itemsLocations = this.$store.state.auth.locations;
      this.itemsDepartment = await this.g_departments();
    },

    openCreate() {
      this.editedIndex = -1;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.image_storage = null;
      this.url_image = "";
      this.date = moment().startOf("month").format("YYYY-MM-DD");
      this.date2 = moment().endOf("month").format("YYYY-MM-DD");
      this.itemsLocations2 = [];
      this.dialog = true;
    },

    async editItem(item) {
      this.editedIndex = this.projects.indexOf(item);
      this.editedItem = Object.assign({}, item);

      this.date = this.editedItem.start_date;
      this.date2 = this.editedItem.end_date;
      this.filters.business = this.editedItem.business_unit_id;
      this.filters.location = this.editedItem.location_id;
      this.url_image = "";

      this.itemsLocations2 = this.updateCombo(
        this.itemsLocations,
        this.itemsLocations2,
        this.editedItem.business_unit_id,
        "location"
      );

      // contract_url se guarda como una URL ya resuelta. Si es un valor
      // legado/inválido ("[object Object]", "null", etc.) se ignora.
      this.image_storage = this.isHttpUrl(this.editedItem.contract_url)
        ? this.editedItem.contract_url
        : null;

      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.projects.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.projects.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.image_storage = null;
        this.url_image = "";
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save() {
      if (this.editedItem.business_unit_id == null) {
        this.$toast.info("Debes seleccionar una unidad de negocio !!!");
        return;
      }
      if (this.editedItem.location_id == null) {
        this.$toast.info("Debes seleccionar una location!!!");
        return;
      }
      if (
        this.editedItem.name == "" ||
        this.editedItem.name == undefined ||
        this.editedItem.name == null
      ) {
        this.$toast.info("Debes elegir un nombre!!!");
        return;
      }
      if (
        this.editedItem.code == "" ||
        this.editedItem.code == undefined ||
        this.editedItem.code == null
      ) {
        this.$toast.info("Debes elegir un código!!!");
        return;
      }

      this.saving = true;
      try {
        // Conserva el contrato existente si no se sube uno nuevo.
        let record_url = this.isHttpUrl(this.editedItem.contract_url)
          ? this.editedItem.contract_url
          : null;

        if (this.url_image != "") {
          const fileInput = document.getElementById("fileInput");
          const record = await this.upload_images("contracts", fileInput);
          // Guarda una URL ya resuelta (string), no el objeto del registro.
          record_url = this.get_storage(record) || record_url;
        }

        let data = {
          in_diary_book_category_id:
            this.editedItem.id == undefined ? null : this.editedItem.id,
          bussiness_unit_id: this.editedItem.business_unit_id,
          location_id:
            this.editedItem.location_id == undefined
              ? null
              : this.editedItem.location_id,
          department_id:
            this.editedItem.department_id == undefined
              ? null
              : this.editedItem.department_id,
          created_by: this.$store.state.auth.user.user.user_id,
          code: this.editedItem.code,
          name: this.editedItem.name,
          start_date: this.date,
          end_date: this.date2,
          contract_code: this.editedItem.contract_code,
          contract_url: record_url,
          finished: true,
        };

        const response = await this.api_Post("project/projects", data);
        if (response.status == 200) {
          this.$toast.success("Proyecto guardado con éxito");
          this.init();
          this.close();
        } else {
          this.$toast.error("Error al guardar");
        }
      } catch (e) {
        this.$toast.error("error " + e.message);
      } finally {
        this.saving = false;
      }
    },

    isHttpUrl(v) {
      return typeof v === "string" && /^https?:\/\//i.test(v);
    },

    getDate(date) {
      return moment(date).format("YYYY-MM-DD HH:MM:SS A").toString();
    },

    takeImage() {
      document.getElementById("fileInput").click();
    },

    onFileChange() {
      this.image_storage = this.url_image
        ? URL.createObjectURL(this.url_image)
        : null;
    },

    updateCombo(itemsOrigen, itemsDestino, condicion, combo) {
      itemsDestino.splice(0, itemsDestino.length);
      for (let item of itemsOrigen) {
        if (item.bus_id === condicion) {
          itemsDestino.push({
            value: item.value,
            text: item.text,
            routes: item.routes,
          });
        }
      }
      return itemsDestino;
    },
  },
};
</script>
